import { StatusEffects } from "./statusEffects.js";

export const WeaponSubtypes = {
  DAGGER: {
    name: "Dagger",
    mods: { damage: 5, attackSpeed: 25, statusEffect: StatusEffects.BLEED },
  },
  SHORTSWORD: {
    name: "Shortsword",
    mods: { damage: 10, attackSpeed: 40, lifesteal: 10 },
  },
  LONGSWORD: {
    name: "Longsword",
    mods: { damage: 15, attackSpeed: 60 },
  },
  CLUB: {
    name: "Club",
    mods: { damage: 8, attackSpeed: 50, statusEffect: StatusEffects.STUN },
  },
  CROSSBOW: {
    name: "Crossbow",
    magazineSize: 1,
    mods: { damage: 20, attackSpeed: 75 },
  },
  REVOLVER: {
    name: "Revolver",
    magazineSize: 6,
    mods: {
      damage: 25,
      attackSpeed: 40,
      critChance: 5,
      critMultiplier: 1.5,
    },
  },
};
